"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconShare6 = void 0;
var _react = _interopRequireDefault(require("react"));
var AccessibleIcon = _interopRequireWildcard(require("@radix-ui/react-accessible-icon"));
var _Icons = require("../Icons.constants");
var _IconModule = _interopRequireDefault(require("../Icon.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var IconShare6 = _ref => {
  var className = _ref.className,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? _Icons.DEFAULT_LABEL : _ref$label,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? _Icons.DEFAULT_COLOR : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _Icons.DEFAULT_SIZE : _ref$size,
    _ref$isFilled = _ref.isFilled,
    isFilled = _ref$isFilled === void 0 ? false : _ref$isFilled;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: size,
      width: size
    },
    className: (0, _classnames.default)(className, _IconModule.default.Container)
  }, /*#__PURE__*/_react.default.createElement(AccessibleIcon.Root, {
    label: label
  }, isFilled ? /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3373 3.13951C10.6304 2.77988 11.0734 2.57612 11.5372 2.58762C11.9438 2.59771 12.2509 2.80148 12.4055 2.91154C12.5703 3.02886 12.758 3.18975 12.9441 3.34931C12.9532 3.35713 12.9623 3.36495 12.9714 3.37276L21.4618 10.6502C21.5662 10.7396 21.6875 10.8436 21.7853 10.9431C21.8959 11.0558 22.0507 11.2348 22.1434 11.4929C22.2611 11.8208 22.2611 12.1793 22.1434 12.5072C22.0507 12.7653 21.8959 12.9443 21.7853 13.057C21.6875 13.1565 21.5662 13.2604 21.4618 13.3499L12.944 20.6508C12.758 20.8104 12.5703 20.9712 12.4055 21.0886C12.2509 21.1986 11.9438 21.4024 11.5372 21.4125C11.0734 21.424 10.6304 21.2202 10.3373 20.8606C10.0803 20.5453 10.0352 20.1795 10.0181 19.9905C9.99991 19.789 9.99995 19.5418 10 19.2967L10 16.1964C9.0578 16.3593 8.14001 16.6518 7.27329 17.0676C5.92197 17.7158 4.72673 18.6485 3.76944 19.8017C3.5003 20.1259 3.05681 20.2467 2.66047 20.1036C2.26413 19.9605 2 19.5844 2 19.163V18.551C2.00136 15.9303 2.96754 13.4013 4.71418 11.4474C6.1266 9.86748 7.9694 8.75275 10 8.22857V4.73942C10 4.72743 10 4.71542 10 4.7034C9.99995 4.45828 9.99991 4.2111 10.0181 4.00958C10.0352 3.82055 10.0803 3.45479 10.3373 3.13951Z",
    fill: color
  })) : /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.7914 12.6075C21.0355 12.3982 21.1575 12.2936 21.2023 12.1691C21.2415 12.0598 21.2415 11.9403 21.2023 11.831C21.1575 11.7065 21.0355 11.6019 20.7914 11.3926L12.3206 4.13202C11.9004 3.77182 11.6903 3.59172 11.5124 3.58731C11.3578 3.58348 11.2101 3.6514 11.1124 3.77128C11 3.90921 11 4.18595 11 4.73942V9.03468C8.86532 9.40813 6.91159 10.4898 5.45971 12.1139C3.87682 13.8846 3.00123 16.176 3 18.551V19.163C4.04934 17.8989 5.35951 16.8766 6.84076 16.166C8.1467 15.5395 9.55842 15.1684 11 15.0706V19.2607C11 19.8141 11 20.0909 11.1124 20.2288C11.2101 20.3487 11.3578 20.4166 11.5124 20.4128C11.6903 20.4084 11.9004 20.2283 12.3206 19.8681L20.7914 12.6075Z",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
exports.IconShare6 = IconShare6;
//# sourceMappingURL=IconShare6.js.map